import { store } from '..';
import { groupBy } from 'lodash';
import { useSnapshot } from 'valtio';

import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';

import { getAvatarByManufacturerName } from '@/utils';

interface ManufacturerAvatarListProps {
  onClick: () => void;
}

function ManufacturerAvatarList(props: ManufacturerAvatarListProps) {
  const { onClick } = props;
  const snap = useSnapshot(store);

  const groups = groupBy(
    snap.refrigerationUnitModels.filter((model) => model.selected),
    'manufacturer.name',
  );

  return (
    <Stack
      direction="column"
      spacing={1}
      alignItems="center"
      sx={{ mr: 0.5, cursor: 'pointer' }}
      onClick={onClick}
    >
      {Object.entries(groups).map(([manufacturerName, models]) => (
        <Tooltip
          key={manufacturerName}
          title={`${models.length} model${models.length > 1 ? 's' : ''} selected`}
          placement="right"
          arrow
        >
          <Box key={manufacturerName}>
            <Badge
              overlap="circular"
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              badgeContent={models.filter((model) => model.selected).length}
              color="primary"
              slotProps={{
                badge: {
                  style: {
                    fontSize: 10,
                    minWidth: 14,
                    width: 14,
                    height: 14,
                    borderRadius: 0,
                    borderBottomLeftRadius: 4,
                    borderTopRightRadius: 4,
                    padding: 0,
                    margin: 1,
                  },
                },
              }}
            >
              <Paper elevation={2}>
                <Avatar
                  variant="rounded"
                  slotProps={{ img: { sx: { objectFit: 'contain' } } }}
                  src={getAvatarByManufacturerName(manufacturerName)}
                  sx={{
                    p: 0.5,
                    width: 48,
                    height: 48,
                  }}
                >
                  {manufacturerName.charAt(0)}
                </Avatar>
              </Paper>
            </Badge>
          </Box>
        </Tooltip>
      ))}
    </Stack>
  );
}

export { ManufacturerAvatarList };
